export default "__VITE_ASSET__BsaW74rZ__"